import { _ as ot } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.parse-int-d7709701.js";
import { QUERIES as A } from "@ucl/shared-component-foundations";
import { useCustomTranslation as at } from "@ucl/ucl-translation";
import { useMemo as rt, useState as F, useRef as pt, useEffect as et } from "react";
import c from "styled-components";
import "./es.object.keys-9d66766f.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as mt } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as tt } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as lt } from "./useWindowSize.js";
import { Button as nt } from "./button.js";
import { _ as X, T as st } from "./index-f5b44da3.js";
import { a as b } from "./index-5d0f31c6.js";
import { ScreenReaderOnly as ct } from "./screenReaderOnly.js";
import { useAccessibilityProps as ut } from "./accessibility.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import { uniqueId as gt } from "./uniqueId.js";
import "./es.array.from-fe752fa6.js";
import "./es.string.iterator-5de8a61e.js";
import { jsxs as I, jsx as e } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./string-trim-14e37ad3.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./index-8b07dec9.js";
import "./combineRefs-c9ad2c39.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.symbol.description-6025a604.js";
import "./es.string.search-d27ec57a.js";
import "./es.string.trim-6e13db75.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.function.name-b230e7d4.js";
import "./es.date.to-string-6ed49878.js";
import "react-dom";
import "./aria.js";
import "./helperText.js";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./label.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./popupTip-06ee114c.js";
import "./usePopoverIndex.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./iconButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./string-html-forced-a746405b.js";
import "./tooltip.js";
import "./es.global-this-a7f40ce1.js";
import "./carousel.js";
import "./useMediaQuery.js";
import "./index-f2264f1e.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./badge.js";
import "./es.string.small-23219181.js";
var S = "...", E = function(n, o) {
  var u = o - n + 1;
  return Array.from({
    length: u
  }, function(m, l) {
    return l + n;
  });
}, dt = function(n) {
  var o = n.totalCount, u = n.siblingCount, m = u === void 0 ? 1 : u, l = n.currentPage, T = rt(function() {
    var x = m + 5;
    if (x >= o)
      return E(1, o);
    var P = Math.max(l - m, 1), v = Math.min(l + m, o), h = P > 1, C = v < o - 1, f = 1, _ = o;
    if (!h && C) {
      var w = 3 + 2 * m, k = E(1, w - 2);
      return [].concat(k, [S, o]);
    }
    if (h && !C) {
      var D = 3 + 2 * m, W = E(o - D + 3, o);
      return [f, S].concat(W);
    }
    if (h && C) {
      var g = E(P + 1, v - 1);
      return [f, S].concat(g, [S, _]);
    }
  }, [o, m, l]);
  return T;
}, ht = ["totalItems", "page", "initialItemsPerPage", "itemsPerPage", "onItemsPerPageChange", "onPageChange", "showTotalItems", "showPerPageOption", "perPageLabel", "itemsLabel", "placeholder", "exceedOverflow", "children", "menuWidth"], it = /* @__PURE__ */ c.div.withConfig({
  displayName: "pagination__MobileWrapper",
  componentId: "occao6-0"
})(["display:", ";justify-content:", ";align-items:", ";@media ", "{display:", ";}"], function(t) {
  return t.theme.components.pagination.MobileWrapper.display;
}, function(t) {
  return t.theme.components.pagination.MobileWrapper.justifyContent;
}, function(t) {
  return t.theme.components.pagination.MobileWrapper.alignItems;
}, A.tabletAndUp, function(t) {
  return t.theme.components.pagination.MobileWrapper.tabletAndUp.display;
}), ft = /* @__PURE__ */ c(it).withConfig({
  displayName: "pagination__MobileWithButton",
  componentId: "occao6-1"
})(["gap:", ";@media ", "{max-width:", ";}&& > button{min-width:", ";min-height:", ";padding:", ";font-family:", ";font-size:", ";font-weight:", ";line-height:", ";gap:", ";> div{margin:", ";}}"], function(t) {
  return t.theme.components.pagination.MobileWithButton.gap;
}, A.mobile, function(t) {
  return t.theme.components.pagination.MobileWithButton.mobile.maxWidth;
}, function(t) {
  return t.theme.components.pagination.MobileWithButton.button.minWidth;
}, function(t) {
  return t.theme.components.pagination.MobileWithButton.button.minHeight;
}, function(t) {
  return t.theme.components.pagination.MobileWithButton.button.padding;
}, function(t) {
  return t.theme.components.pagination.MobileWithButton.button.fontFamily;
}, function(t) {
  return t.theme.components.pagination.MobileWithButton.button.fontSize;
}, function(t) {
  return t.theme.components.pagination.MobileWithButton.button.fontWeight;
}, function(t) {
  return t.theme.components.pagination.MobileWithButton.button.lineHeight;
}, function(t) {
  return t.theme.components.pagination.MobileWithButton.button.gap;
}, function(t) {
  return t.theme.components.pagination.MobileWithButton.button.div.margin;
}), bt = /* @__PURE__ */ c(it).withConfig({
  displayName: "pagination__MobileDefaultView",
  componentId: "occao6-2"
})(["gap:", ";"], function(t) {
  return t.theme.components.pagination.MobileDefaultView.gap;
}), Pt = /* @__PURE__ */ c.span.withConfig({
  displayName: "pagination__TextWrapper",
  componentId: "occao6-3"
})(["width:", ";display:", ";justify-content:", ";font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";"], function(t) {
  return t.theme.components.pagination.TextWrapper.width;
}, function(t) {
  return t.theme.components.pagination.TextWrapper.display;
}, function(t) {
  return t.theme.components.pagination.TextWrapper.justifyContent;
}, function(t) {
  return t.theme.components.pagination.TextWrapper.fontFamily;
}, function(t) {
  return t.theme.components.pagination.TextWrapper.fontSize;
}, function(t) {
  return t.theme.components.pagination.TextWrapper.fontWeight;
}, function(t) {
  return t.theme.components.pagination.TextWrapper.lineHeight;
}, function(t) {
  return t.theme.components.pagination.TextWrapper.color;
}), vt = /* @__PURE__ */ c.ul.withConfig({
  displayName: "pagination__ListWrapper",
  componentId: "occao6-4"
})(["display:", ";margin:", ";padding:", ";@media ", "{display:", ";align-items:", ";list-style-type:", ";gap:", ";}"], function(t) {
  return t.theme.components.pagination.ListWrapper.display;
}, function(t) {
  return t.theme.components.pagination.ListWrapper.margin;
}, function(t) {
  return t.theme.components.pagination.ListWrapper.padding;
}, A.tabletAndUp, function(t) {
  return t.theme.components.pagination.ListWrapper.tabletAndUp.display;
}, function(t) {
  return t.theme.components.pagination.ListWrapper.tabletAndUp.alignItems;
}, function(t) {
  return t.theme.components.pagination.ListWrapper.tabletAndUp.listStyleType;
}, function(t) {
  return t.theme.components.pagination.ListWrapper.tabletAndUp.gap;
}), H = /* @__PURE__ */ c.li.withConfig({
  displayName: "pagination__ListItem",
  componentId: "occao6-5"
})(["height:", ";width:", ";"], function(t) {
  return t.theme.components.pagination.ListItem.height;
}, function(t) {
  return t.theme.components.pagination.ListItem.width;
}), q = /* @__PURE__ */ c.button.withConfig({
  displayName: "pagination__NavButton",
  componentId: "occao6-6"
})(["padding:", ";display:", ";align-items:", ";justify-content:", ";background-color:", ";border-radius:", ";cursor:", ";color:", ";border:", ";&:focus-visible{outline:", ";}&:disabled{cursor:", ";color:", ";}&:hover:not([disabled]){background-color:", ";}"], function(t) {
  return t.theme.components.pagination.NavButton.padding;
}, function(t) {
  return t.theme.components.pagination.NavButton.display;
}, function(t) {
  return t.theme.components.pagination.NavButton.alignItems;
}, function(t) {
  return t.theme.components.pagination.NavButton.justifyContent;
}, function(t) {
  return t.theme.components.pagination.NavButton.backgroundColor;
}, function(t) {
  return t.theme.components.pagination.NavButton.borderRadius;
}, function(t) {
  return t.theme.components.pagination.NavButton.cursor;
}, function(t) {
  return t.theme.components.pagination.NavButton.color;
}, function(t) {
  return t.theme.components.pagination.NavButton.border;
}, function(t) {
  return t.theme.components.pagination.NavButton.focusVisible.outline;
}, function(t) {
  return t.theme.components.pagination.NavButton.disabled.cursor;
}, function(t) {
  return t.theme.components.pagination.NavButton.disabled.color;
}, function(t) {
  return t.theme.components.pagination.NavButton.hoverNotDisabled.backgroundColor;
}), Ct = /* @__PURE__ */ c.a.withConfig({
  displayName: "pagination__PageLink",
  componentId: "occao6-7"
})(["display:", ";align-items:", ";justify-content:", ";padding:", ";cursor:", ";border-radius:", ";color:", ";font-family:", ";font-size:", ";font-weight:", ";line-height:", ";&:focus-visible{", "}", ";&:hover{background-color:", ";}"], function(t) {
  return t.theme.components.pagination.PageLink.display;
}, function(t) {
  return t.theme.components.pagination.PageLink.alignItems;
}, function(t) {
  return t.theme.components.pagination.PageLink.justifyContent;
}, function(t) {
  return t.theme.components.pagination.PageLink.padding;
}, function(t) {
  return t.theme.components.pagination.PageLink.cursor;
}, function(t) {
  return t.theme.components.pagination.PageLink.borderRadius;
}, function(t) {
  return t.theme.components.pagination.PageLink.color;
}, function(t) {
  return t.theme.components.pagination.PageLink.fontFamily;
}, function(t) {
  return t.theme.components.pagination.PageLink.fontSize;
}, function(t) {
  return t.theme.components.pagination.PageLink.fontWeight;
}, function(t) {
  return t.theme.components.pagination.PageLink.lineHeight;
}, function(t) {
  return !t.$isActive && "outline: " + t.theme.components.pagination.PageLink.focusVisible.active.outline + `;
       outline-offset: ` + t.theme.components.pagination.PageLink.focusVisible.active.outlineOffset + `;
    `;
}, function(t) {
  if (t.$isActive)
    return `
    background-color: ` + t.theme.components.pagination.PageLink.isActive.backgroundColor + `;
    color: ` + t.theme.components.pagination.PageLink.isActive.color + `;
    `;
}, function(t) {
  if (!t.$isActive)
    return t.theme.components.pagination.PageLink.hover.backgroundColor.active;
}), wt = /* @__PURE__ */ c.span.withConfig({
  displayName: "pagination__DotsContainer",
  componentId: "occao6-8"
})(["display:", ";align-items:", ";justify-content:", ";height:", ";width:", ";border-radius:", ";color:", ";padding:", ";box-sizing:", ";&& > svg{transform:", ";}"], function(t) {
  return t.theme.components.pagination.DotsContainer.display;
}, function(t) {
  return t.theme.components.pagination.DotsContainer.alignItems;
}, function(t) {
  return t.theme.components.pagination.DotsContainer.justifyContent;
}, function(t) {
  return t.theme.components.pagination.DotsContainer.height;
}, function(t) {
  return t.theme.components.pagination.DotsContainer.width;
}, function(t) {
  return t.theme.components.pagination.DotsContainer.borderRadius;
}, function(t) {
  return t.theme.components.pagination.DotsContainer.color;
}, function(t) {
  return t.theme.components.pagination.DotsContainer.padding;
}, function(t) {
  return t.theme.components.pagination.DotsContainer.boxSizing;
}, function(t) {
  return t.theme.components.pagination.DotsContainer.svg.transform;
}), yt = /* @__PURE__ */ c.div.withConfig({
  displayName: "pagination__Wrapper",
  componentId: "occao6-9"
})(["", ""], function(t) {
  return `
    display: ` + t.theme.components.dataTable.TablePaginationView.Wrapper.display + `;
    flex-direction: ` + t.theme.components.dataTable.TablePaginationView.Wrapper.flexDirection + `;
    justify-content: ` + (t.$singleChild && t.theme.components.dataTable.TablePaginationView.Wrapper.onlyChild.justifyContent || t.theme.components.dataTable.TablePaginationView.Wrapper.justifyContent) + `;
    gap: ` + t.theme.components.dataTable.TablePaginationView.Wrapper.gap + `;
    @media ` + A.tabletAndUp + ` {
      flex-direction: ` + t.theme.components.dataTable.TablePaginationView.Wrapper.tabletView.flexDirection + `
    `;
}), It = /* @__PURE__ */ c.div.withConfig({
  displayName: "pagination__Container",
  componentId: "occao6-10"
})(["", ""], function(t) {
  return `
    display: ` + t.theme.components.dataTable.TablePaginationView.Container.display + `;
    flex-direction: ` + t.theme.components.dataTable.TablePaginationView.Container.flexDirection + `;
    justify-content: ` + t.theme.components.dataTable.TablePaginationView.Container.justifyContent + `;
    align-items: ` + t.theme.components.dataTable.TablePaginationView.Container.alignItems + `;
    gap: ` + t.theme.components.dataTable.TablePaginationView.Container.gap + `;
    .Pagniation__Control {
      width: ` + t.theme.components.dataTable.TablePaginationView.Container.paginationControl.width + `;
      min-width: ` + t.theme.components.dataTable.TablePaginationView.Container.paginationControl.minWidth + `;
    }
    .DropdownBase__wrapper {
      width: ` + t.theme.components.dataTable.TablePaginationView.Container.paginationControl.width + `;
    }
    @media ` + A.tabletAndUp + ` {
      flex-direction: ` + t.theme.components.dataTable.TablePaginationView.Container.tabletView.flexDirection + `;
      justify-content: ` + t.theme.components.dataTable.TablePaginationView.Container.tabletView.justifyContent + `;
      width: ` + t.theme.components.dataTable.TablePaginationView.Container.tabletView.width + `;
      .Pagniation__Control {
        width: ` + t.theme.components.dataTable.TablePaginationView.Container.tabletView.paginationControl.width + `;
      }
      .DropdownBase__wrapper {
        width: unset;
      }
    }
    `;
}), Tt = /* @__PURE__ */ c.span.withConfig({
  displayName: "pagination__ItemsPerPageDisplay",
  componentId: "occao6-11"
})(["", ""], function(t) {
  return `
    width: ` + t.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.width + `;
    font-family: ` + t.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.fontFamily + `;
    color: ` + t.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.color + `;
    font-size: ` + t.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.fontSize + `;
    font-weight: ` + t.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.fontWeight + `;
    line-height: ` + t.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.lineHeight + `;
    `;
}), xt = function(n) {
  var o, u, m, l, T, x, P, v, h = n.itemsPerPage, C = h === void 0 ? 1 : h, f = n.totalItems, _ = f === void 0 ? 10 : f, w = n.siblingCount, k = w === void 0 ? 2 : w, D = n.page, W = D === void 0 ? 1 : D, g = n.onPageChange, M = n.variant, G = M === void 0 ? "default" : M, z = n.children, Q = mt({
    label: "Pagination"
  }), N = lt().width < 600, d = tt(z, {
    PreviousButton: K.PreviousButton,
    NextButton: K.NextButton
  }, tt.PickType.LAST), R = F(1), a = R[0], B = R[1], r = Math.ceil(_ / C), U = at("Pagination"), j = U.t;
  et(function() {
    W !== a && B(W);
  }, [W]);
  var V = function(i) {
    B(i), g && g(i);
  }, O = function() {
    if (a > 1) {
      var i = a - 1;
      B(i), g && g(i);
    }
  }, L = function() {
    if (a < r) {
      var i = a + 1;
      B(i), g && g(i);
    }
  }, J = dt({
    totalCount: r,
    siblingCount: k,
    currentPage: a
  });
  return /* @__PURE__ */ I("nav", Object.assign({}, Q, {
    children: [G !== "default" ? N && /* @__PURE__ */ I(ft, {
      children: [/* @__PURE__ */ e(nt, Object.assign({
        size: "medium",
        variant: "secondary",
        fullWidthMobile: !1,
        leftIcon: /* @__PURE__ */ e(b, {
          icon: "caretLeft"
        }),
        disabled: a === 1,
        onClick: O,
        "aria-label": "Previous"
      }, (o = d.PreviousButton) == null ? void 0 : o.props, {
        children: ((u = d.PreviousButton) == null ? void 0 : u.props.children) || "Previous"
      })), /* @__PURE__ */ e(nt, Object.assign({
        size: "medium",
        variant: "secondary",
        fullWidthMobile: !1,
        rightIcon: /* @__PURE__ */ e(b, {
          icon: "caretRight"
        }),
        disabled: a === r,
        onClick: L,
        "aria-label": "Next"
      }, (m = d.NextButton) == null ? void 0 : m.props, {
        children: ((l = d.NextButton) == null ? void 0 : l.props.children) || "Next"
      }))]
    }) : N && /* @__PURE__ */ I(bt, {
      children: [/* @__PURE__ */ e(q, Object.assign({
        tabIndex: 0,
        onClick: O,
        disabled: a === 1,
        "aria-label": "prev"
      }, (T = d.PreviousButton) == null ? void 0 : T.props, {
        children: /* @__PURE__ */ e(b, {
          icon: "caretLeft",
          size: "l"
        })
      })), /* @__PURE__ */ I(Pt, {
        children: [a, " of ", r]
      }), /* @__PURE__ */ e(q, Object.assign({
        onClick: L,
        disabled: a === r,
        tabIndex: 0,
        "aria-label": "next"
      }, (x = d.NextButton) == null ? void 0 : x.props, {
        children: /* @__PURE__ */ e(b, {
          icon: "caretRight",
          size: "l"
        })
      }))]
    }), /* @__PURE__ */ I(vt, {
      children: [/* @__PURE__ */ e(H, {
        children: !N && /* @__PURE__ */ e(q, Object.assign({
          tabIndex: 0,
          onClick: O,
          disabled: a === 1,
          "aria-label": "prev"
        }, (P = d.PreviousButton) == null ? void 0 : P.props, {
          children: /* @__PURE__ */ e(b, {
            icon: "caretLeft",
            size: "l"
          })
        }))
      }), J.map(function(s, i) {
        if (s === S)
          return /* @__PURE__ */ e(H, {
            children: /* @__PURE__ */ e(wt, {
              children: /* @__PURE__ */ e(b, {
                icon: "moreVertical",
                height: "10px",
                width: "10px"
              })
            })
          }, i);
        var p = s === a ? "" + j("current page", "page") : j("Go to Page") + " " + s;
        return /* @__PURE__ */ e(H, {
          children: /* @__PURE__ */ e(Ct, {
            "aria-label": p,
            $isActive: s === a,
            onClick: function() {
              return V(s);
            },
            tabIndex: 0,
            onKeyDown: function($) {
              ($.code === "Enter" || $.code === "Space") && V(s);
            },
            className: "PageLink",
            children: s
          })
        }, i);
      }), /* @__PURE__ */ e(H, {
        children: !N && /* @__PURE__ */ e(q, Object.assign({
          onClick: L,
          disabled: a === r,
          tabIndex: 0,
          "aria-label": "next"
        }, (v = d.NextButton) == null ? void 0 : v.props, {
          children: /* @__PURE__ */ e(b, {
            icon: "caretRight",
            size: "l"
          })
        }))
      })]
    }), /* @__PURE__ */ e(ct, {
      "aria-live": "polite",
      "aria-atomic": "true",
      children: a + " of " + r
    })]
  }));
}, K = function(n) {
  var o = n.totalItems, u = n.page, m = n.initialItemsPerPage, l = m === void 0 ? 5 : m, T = n.itemsPerPage, x = n.onItemsPerPageChange, P = n.onPageChange, v = n.showTotalItems, h = v === void 0 ? !1 : v, C = n.showPerPageOption, f = C === void 0 ? !1 : C, _ = n.perPageLabel, w = _ === void 0 ? "per page" : _, k = n.itemsLabel, D = k === void 0 ? "of items" : k, W = n.placeholder, g = n.exceedOverflow, M = g === void 0 ? !1 : g, G = n.children, z = n.menuWidth, Q = z === void 0 ? "280px" : z, N = ot(n, ht), d = F([]), R = d[0], a = d[1], B = F(""), r = B[0], U = B[1], j = F(!1), V = j[0], O = j[1], L = pt(gt("pagination"));
  et(function() {
    if (l) {
      for (var i = [], p = 1; p <= 5; p++)
        i.push({
          label: l * p + " " + w,
          value: "" + l * p
        });
      a(i), U(T + " " + w);
    }
  }, [T, l]);
  var J = ut("combobox", {
    ariaExpanded: V,
    ariaHasPopup: "listbox",
    ariaControls: "list-" + L.current,
    ariaLabel: "" + r,
    ariaLabelledBy: void 0
  }), s = function() {
    var p = u || 1, y = parseInt(r) || 1, $ = (p - 1) * y, Y = $ + y, Z = D.split(" ");
    return $ + 1 + " - " + (Y > o ? o : Y) + " " + Z[0] + " " + o + " " + Z[1];
  };
  return /* @__PURE__ */ I(yt, {
    $singleChild: !(f || h),
    children: [!!(f || h) && /* @__PURE__ */ I(It, {
      children: [f && /* @__PURE__ */ I(X, {
        exceedOverflow: M,
        menuDirection: M ? "auto" : "down_left",
        menuOpen: V,
        handleMenuOpen: function(p) {
          O(p);
        },
        menuWidth: Q,
        uniqueIdentifier: L.current,
        closeOnSelect: !0,
        onChange: function(p, y) {
          y.value + " " + w !== r && (U(y.label), x && x(parseInt(y.value)));
        },
        children: [/* @__PURE__ */ e(X.Control, {
          className: "Pagniation__Control",
          children: /* @__PURE__ */ e(st, Object.assign({
            placeholder: W,
            readOnly: !0,
            value: r,
            id: "control-" + L.current,
            endAdornmentProp: {
              endAdornment: V ? /* @__PURE__ */ e(b, {
                icon: "caretUp",
                style: {
                  pointerEvents: "none"
                }
              }) : /* @__PURE__ */ e(b, {
                icon: "caretDown",
                style: {
                  pointerEvents: "none"
                }
              })
            }
          }, J))
        }), R.map(function(i) {
          return /* @__PURE__ */ e(X.Item, {
            value: i.value,
            label: i.label,
            isSelected: r === i.label
          }, i.value);
        })]
      }), h && /* @__PURE__ */ e(Tt, {
        children: s()
      })]
    }), /* @__PURE__ */ e(xt, Object.assign({
      totalItems: o,
      page: u,
      itemsPerPage: parseInt(r) || 1,
      onPageChange: function(p) {
        u !== p && P && P(p);
      }
    }, N, {
      children: G
    }))]
  });
};
K.PreviousButton = function(t) {
  return /* @__PURE__ */ e("button", Object.assign({}, t));
};
K.NextButton = function(t) {
  return /* @__PURE__ */ e("button", Object.assign({}, t));
};
export {
  K as Pagination
};
